export function getBase64Content(base64Data: string): string {
  return base64Data.replace(/^data:image\/[a-z]+;base64,/, '')
}
